export const validCredentialsc1 = [
   
    { expirationDate:"05/12/35",nivel:"C2",usuario: 'heygen', password: 'ia', realname: 'MyEnglishBro!', img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
   
         { expirationDate:"30/09",nivel:"B2",usuario: 'laura', password: 'sanchez', realname: 'Laura Sanchez', img: 'https://i.ibb.co/jv0jDGgs/Chat-GPT-Image-6-jul-2025-13-23-34.png' }, // No image


      { expirationDate:"08/10",nivel:"c1",usuario: 'esteban', password: 'bello', realname: 'Esteban Bello', img: 'https://i.ibb.co/jv0jDGgs/Chat-GPT-Image-6-jul-2025-13-23-34.png' }, // No image


    // { expirationDate:"17/03/25",nivel:"B2/C1 ",usuario: 'franco', password: 'leon', realname: 'Franco Leon', img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png' }, // No image
     { expirationDate:"29/09/25",nivel:"C1",usuario: 'melisa', password: 'ramos', realname: 'Melisa Ramos',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
    { expirationDate:"Unlimited Account",nivel:"C1",usuario: 'andri', password: 'morales', realname: 'Andrineth morales',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
           { expirationDate:"Unlimited Account",nivel:"C1",usuario: 'fabricio', password: 'paltan', realname: 'Fabricio Paltan',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},

    ];
